import { Middleware } from "../middleware"
export default {

    getIncidentes(filter) {
        return new Middleware()
            .method('GET')
            .append(`/odin/incidents`)
            .params({
                findBy: filter.search,
                page: filter.page,
                size: filter.size,
                startDate: filter.rangeDate?.start,
                endDate: filter.rangeDate?.end,
                idCompany: filter.idCompany,
                status: filter.status,
                idAnalyst: filter.idAnalyst,
                severity: filter.severity


            })
            .build()
    },
    getIncidentResponsibleList () {
        return new Middleware()
            .method('GET')
            .append(`/requests/5/get_resposible_list`)
            .build()
    },
    getIncidentsDetail(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/incidents/${id}`)
            .build()
    },

    getAlertsIncidents(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/incidents/${id}/alert_occurrences`)
            .build()

    },
    getAlertsIncidentsById(incidentId, alertId) {
        return new Middleware()
            .method('GET')
            .append(`/odin/incidents/${incidentId}/alert_occurrences/${alertId}`)
            .build()

    },



    updateStatusIncidents(id, data) {
        return new Middleware()
            .method('PUT')
            .append(`/odin/incidents/${id}/status_update`)
            .setData(data)
            .build()

    },

    getStatusIncidentsList () {
        return new Middleware()
            .method('GET')
            .append(`/odin/incidents/status_list`)
            .build()

    },

    updateAnalyst(id, data) {
        return new Middleware()
            .method('PUT')
            .append(`/odin/incidents/${id}/assign_analyst`)
            .setData(data)
            .build()
    },

    getMessagesIncidents(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/incidents/${id}/messages`)
            .build()

    },
    

    getHistoryIncidents(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/incidents/${id}/get_history`)
            .build()
    },
    postHistoryIncidents(id, data) {
        return new Middleware()
            .method('POST')
            .setData(data)
            .append(`/odin/incidents/${id}/new_history`)
            .build()
    },

    updateIncident(data,id){
        return new Middleware()
        .method('PUT')
        .setData(data)
        .append(`/odin/incidents/update/${id}`)
        .build()
    },
    getFeedbackMss(id){
        return new Middleware()
        .method('GET')
        .append(`/odin/incidents/${id}/feedbacks/mss`)
        .build()
    },
    addFeedbackMss(data, id, type){
        return new Middleware()
        .method(type)
        .setData(data)
        .append(`/odin/incidents/${id}/feedbacks/mss`)
        .build()
    },
    getFeedbackCompany(id){
        return new Middleware()
        .method('GET')
        .append(`/odin/incidents/${id}/feedbacks/company`)
        .build()
    },
    addFeedbackCompany(data, id, type){
        return new Middleware()
        .method(type)
        .setData(data)
        .append(`/odin/incidents/${id}/feedbacks/company`)
        .build()
    }
}